import React, { useEffect, useMemo, useState } from 'react';
import { Alert } from 'react-bootstrap';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { GetExamDto } from '../../../common/spdCore/autogenerated/spdApiClient';

interface Props {
  examId: string;
  exam: GetExamDto;
}

const stripLabel = (name: string) =>
  name.replace(/ \(wymagane\)$| \(opcjonalne\)$/, '');

export const SupportingExaminationStatusAlert: React.FC<Props> = ({
  examId,
  exam,
}) => {
  const spd = useSpdCore();
  const [missingResults, setMissingResults] = useState<string[]>([]);
  const [allFilled, setAllFilled] = useState(false);

  const requiredOnly = useMemo(
    () =>
      (exam.supportingExaminationDict || []).filter(
        name => !name.endsWith('(opcjonalne)'),
      ),
    [exam.supportingExaminationDict],
  );
  const isRequired = exam.articleWithAutoSupport && requiredOnly.length > 0;

  useEffect(() => {
    if (!isRequired) {
      return;
    }
    spd.support
      .getAllByExam(examId)
      .then(supports => {
        const missing = requiredOnly.filter(name => {
          const stripped = stripLabel(name);
          const match = supports.find(s => s.examKindDict?.name === stripped);
          return !match || !match.result;
        });
        setMissingResults(missing.map(stripLabel));
        setAllFilled(missing.length === 0);
      })
      .catch(err => console.error('Błąd pobierania badań pomocniczych:', err));
  }, [examId, isRequired, requiredOnly, spd.support]);

  if (!isRequired) {
    return null;
  }

  if (allFilled) {
    return (
      <Alert variant="success" className="mt-2">
        Wszystkie wymagane badania pomocnicze i konsultacje posiadają wyniki.
      </Alert>
    );
  }

  if (missingResults.length > 0) {
    return (
      <Alert variant="danger" className="mt-2">
        {'Brak wyników dla: '}
        <strong>{missingResults.join(', ')}</strong>
      </Alert>
    );
  }

  return null;
};
